import React from 'react';
import * as PropTypes from 'prop-types';
import ServerLanguage from '../../Util/ServerLanguage';
import InvestorCard from '../../Components/InvestorCard/InvestorCard';

const InvestorCardTwig = ({
  preFetchedInvestors = null,
  locale = null,
  currencyCode = null,
  hasOverflow = false
}) => {
  // convert preFetchedInvestors string to JSON
  const preRenderedInvestors = JSON.parse(preFetchedInvestors);

  const investors = preRenderedInvestors || [];

  return (
    investors?.length ? (
      <div
        className={`${
          hasOverflow
            ? 'flex md:flex-row flex-col md:items-stretch items-center md:overflow-auto scrollbar-hide'
            : 'grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 md:max-w-(--breakpoint-xl) mx-auto'
        } w-full`}
      >
        {investors.map((investor) => {
          return (
            <InvestorCard
              key={investor.detailsUrl}
              investor={investor}
              locale={locale}
              isLoggedIn={false}
              currencyCode={currencyCode}
            />
          );
        })}
      </div>
    ) : (<span />)
  );
};

const InvestorCardTwigWithLanguage = ({ language = null, ...props }) => {
  return (
    <ServerLanguage language={language}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <InvestorCardTwig {...props} />
    </ServerLanguage>
  );
};

export default InvestorCardTwigWithLanguage;

InvestorCardTwig.propTypes = {
  preFetchedInvestors: PropTypes.string,
  locale: PropTypes.string,
  currencyCode: PropTypes.string,
  hasOverflow: PropTypes.bool
};

InvestorCardTwigWithLanguage.propTypes = {
  language: PropTypes.string
};
